@if (showLoading && !creatureRef && !selectedCreature) {
<section *ngIf="showLoading" class="loader-box">
  <span class="loader"></span>
</section>
} @else if (creatureRef && selectedCreature) {
<div class="breeding">
  <div class="breeding-popup">
    <div class="breeding__container">
      <div class="breeding__body">
        <button class="breeding__close" [routerLink]="['/', lang, 'marketplace', 'view', creatureRef!.id]">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14.192 4.34399L9.94897 8.58599L5.70697 4.34399L4.29297 5.75799L8.53497 9.99999L4.29297 14.242L5.70697 15.656L9.94897 11.414L14.192 15.656L15.606 14.242L11.364 9.99999L15.606 5.75799L14.192 4.34399Z"
              fill="white" />
          </svg>
        </button>
        <h2 class="breeding__title">{{ 'breeding.title' | translate }}</h2>
        <div class="breeding__inner">
          <div class="breeding__user">
            <div class="breeding__user-left">
              <img class="breeding__user-img" [src]="creatureRef.imageUrl" alt="Item">
              <h4 class="breeding__user-count" *ngIf="creatureRef.breedingMaxCount">{{
                'breeding.breed_count' | translate }}</h4>
              <div class="breeding__user-num" *ngIf="creatureRef.breedingMaxCount">
                {{creatureRef.breedingCount}} / {{creatureRef.breedingMaxCount}}</div>
            </div>
            <div class="breeding__user-coin">
              <h4 class="breeding__user-count">{{ 'breeding.required_coins' | translate }}</h4>
              <div class="breeding__user-circle">
                <img src="/assets/image/breeding/coin.png" alt="Coin">
                <div class="breeding__user-num">1800<span> / 1000</span></div>

              </div>
              <div class="breeding__user-line"></div>
              <div class="breeding__user-line down"></div>

            </div>

            <div class="breeding__user-right">
              <img class="breeding__user-img"
                [src]="selectedCreature ? selectedCreature.imageUrl : '/assets/image/breeding/person.png'" alt="person">
              <div class="breeding__user-select">{{(selectedCreature ? selectedCreature.nftTokenId :
                'Select an Elysium')}}</div>
            </div>
          </div>
          <div class="breeding__result">
            <h4 class="breeding__result-title">{{ 'breeding.breeding_fee' | translate: { fee: 0.05 } }}</h4>
            <button class="button-big" [ngClass]="{'disabled': !selectedCreature}" (click)="onBreed()">
              {{ 'breeding.breed_button' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<section *ngIf="showLoading" class="loader-box">
  <span class="loader"></span>
</section>
}